export interface EventLog {
    id?: number,
    description?: string,
    run_at?: number
}